import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getBranding } from '@/api/branding';

export const DEFAULT_BRAND_NAME = 'Ads Admin';

// The product name, as set on the Settings page. Falls back to the default
// while loading or when the API is unreachable so chrome never renders empty.
export function useBranding(): { name: string } {
  const { data } = useQuery({
    queryKey: ['branding'],
    queryFn: getBranding,
    staleTime: Infinity,
  });
  return { name: data?.name?.trim() || DEFAULT_BRAND_NAME };
}

export function useBrandTitle(suffix = 'Dashboard') {
  const { name } = useBranding();
  useEffect(() => {
    document.title = suffix ? `${name} ${suffix}` : name;
  }, [name, suffix]);
}
